import React, { useState, useContext } from "react";
import "../../../../../../../css/weigh-in.sass"
import "../../../../../../../css/highlow.sass"
import "../../../../../../../css/select-goal.sass"
import styled from "styled-components";
import { Accordion } from "../components/setting-accordion";
import { SaveButton } from "../components/save-button";
import Dialog from "@material-ui/core/Dialog";
import ChangeGoal from "./index"
import FatLoss from "../../../../../../../images/change-goal-pictures/weight-loss-2020.png";
import MuscleGain from "../../../../../../../images/change-goal-pictures/muscle-gain-2020.png";
import Reverse from "../../../../../../../images/change-goal-pictures/reverse-2020.png";
import Maintenance from "../../../../../../../images/change-goal-pictures/maintenance-2020.png";
import Icon from '@material-ui/core/Icon';
import { getDaysSinceWeighIn } from '../../../util'
import { ThemeContext } from 'styled-components'
import VacationModeModal from '../vacation-mode-modal'

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const UpdateGoal = (props) => {
  const theme = useContext(ThemeContext)
  const [show, setShow] = useState(false);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [showVacationModal, setShowVacationModal] = useState(false);

  // Update Goal props
  let oldSliderVal = 0
  let targetWeight = props.user.target_weight
  let oldModifier = 3.4
  if(props.user.goal === 'REVERSE DIETING') {
    oldSliderVal = Math.round((props.user.goal_min_weekly_calorie_increase - (props.user.gender === 'MALE' ? 35 : 30)) * 100 / 30)
  } else if (props.user.goal === 'FAT LOSS') {
    if(props.user.weight) {
      let fatLossRatio = props.user.goal_weight_delta / props.user.weight
      if (fatLossRatio < 0.004) {
        fatLossRatio = 0.004
      } else if (fatLossRatio > 0.012) {
        fatLossRatio = 0.012
      }
      oldSliderVal = Math.round((fatLossRatio - 0.004) * 100 / 0.008)
    }
  } else if (props.user.goal === 'MUSCLE GAIN') {
    if(props.user.weight) {
      let muscleGainRatio = props.user.goal_weight_delta / props.user.weight
      if (muscleGainRatio < 0.002) {
        muscleGainRatio = 0.002
      } else if (muscleGainRatio > 0.005) {
        muscleGainRatio = 0.005
      }
      oldSliderVal = Math.round((muscleGainRatio - 0.002) * 100 / 0.003)
    }
  } else { // 'MAINTENANCE'
    oldModifier = Math.round((props.user.use_metric_units === 1 ? props.user.goal_weight_delta : (props.user.goal_weight_delta * 2.204622)) * 10) / 10
  }

  const handleClick = () => {
    if(props.vacationMode !== 0) {
      setShowVacationModal(true)
      return
    }
    
    // if (daysAfterLastCheckIn >= 1 && daysAfterLastCheckIn < 5) {
    //   setShowCheckinFormPortal(true);
    // } else if (daysAfterLastCheckIn >= 5) {
    //   setShowUserCheckinWarning(true);
    // } else {
    //   setShowGoalModal(true);
    // }

    setShowGoalModal(true);
  }

  const getIcon = () => {
    const goalIcons = {
      'FAT LOSS': FatLoss,
      'MUSCLE GAIN': MuscleGain,
      'REVERSE DIETING': Reverse,
      'MAINTENANCE': Maintenance
    }

    return goalIcons[props.user.goal]
  }

  const daysAfterLastCheckIn = getDaysSinceWeighIn(props.lastWeighInDate);

  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}
        icon={getIcon()}
        currentSetting={theme.goal[props.user.goal]}
        settingName="Change goal"
        roundTop
      >
        <ButtonRow>
          <SaveButton
            text="Change goal"
            // disabled={disabled}
            onClick={handleClick}
          />
        </ButtonRow>
      </Accordion>
      
      <VacationModeModal
        setting='goal'
        open={showVacationModal}
        onClose={() => setShowVacationModal(false)}
        isPaused={props.vacationMode > 0 && !props.vacationModeInfo?.practice_mode}
      />
      
      <Dialog
        className="inspect-modal-setting"
        fullScreen
        open={showGoalModal}
        onClose={() => setShowGoalModal(false)}
        autoScrollBodyContent={true}
      >
        <div className="check-in-close">
          <button onClick={() => setShowGoalModal(false)}>
            <Icon>close</Icon>
          </button>
        </div>
        <div className="inspect-modal-setting">
          <ChangeGoal
            closeGoalModal={() => setShowGoalModal(false)}
            loadPortalAccount={props.loadPortalAccount}
            openFeedback={props.openSnackbar}
            userId={props.user.id}
            portalId={props.portalId}
            calorieBoost={props.user.calorie_restricted}
            goal={props.user.goal}
            oldSliderVal={oldSliderVal}
            targetWeight={targetWeight}
            oldModifier={oldModifier}
            goal_weight_delta={props.user.goal_weight_delta}
            goal_min_weekly_calorie_increase={props.user.goal_min_weekly_calorie_increase}
            fullname={props.user.full_name}
            vacationMode={props.user.vacation_mode === 1 ? 1 : 0}
            lastWeighInDate={props.user.lastWeighInDate}
            nearPeriod={props.user.near_period}
            resumeGoalChangeMode={false}
            useMetric={Number(props.user.use_metric_units)}
            weighins={props.user.weighins}
            weight={props.user.estimated_weight !== null ? props.user.estimated_weight : props.user.weight}
            isLoading={props.user.isLoading}
            gender={props.user.gender}
            // check in form
            weightString={props.weightString}
            previousWeight={props.previousWeight}
            previousBodyfat={props.previousBodyfat}
            useMetricUnits={props.useMetricUnits}
            daysAfterLastCheckIn={daysAfterLastCheckIn}
          />
        </div>
      </Dialog>
    </>
  );
};

export default UpdateGoal;
